import React from 'react'
import classes from './ReviewComponent.module.css'
const ReviewComponent = (props) => {
    return (
        <div className={classes.Container}>
            <div className={classes.image}>
                {props.image}
            </div>
            <div className={classes.content}>
                <p className={classes.review}>{props.children}</p>
                <p className={classes.name}>- {props.name}</p>
            </div>
        </div>
    )
}
export default ReviewComponent